import { render, staticRenderFns } from "./Tees.vue?vue&type=template&id=15b9c422&"
import script from "./Tees.vue?vue&type=script&lang=js&"
export * from "./Tees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports